module.exports = __webpack_public_path__ + "static/img/bottom.d4b1285.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/bottom.png
// module id = rhnR
// module chunks = 1